<template lang="html">
  <main class="row">

    <div v-if="details.ready" class="col-12 col-md-8 offset-md-2 text-center">

      <h4>Detalles de la compra</h4>

      <!-- Purchase quantity selector and total price calculator -->
      <div class="buy-quantity-details mt-4 row">

          <div class="col-5 text-right px-0">
            <label class="pt-1">Producto:</label>
          </div>
          <div class="col-7 pt-1 text-left">
            {{ details.title }}
          </div>

          <div class="col-5 text-right px-0">
            <label class="pt-1" for="selectQuantity">Precio:</label>
          </div>
          <div class="col-7 pt-1 text-left">
            {{ priceBuyUnit | currency }} (c/u)
          </div>

          <div class="col-5 pt-1 text-right px-0">
            <label class="pt-1" for="selectQuantity">Cantidad:</label>
          </div>
          <div class="col-7 pt-1 text-left">
            <select
              @change="handleQuantityChange"
              id="selectQuantity"
              class="form-control w-auto">
              <template v-for="{value, text} in quantityOptions">
                <option
                  :selected="quantity === value"
                  :key="value"
                  :value="text">
                  {{ text }}
                </option>
              </template>
            </select>
          </div>

          <div class="col-5 text-right px-0">
            <label class="pt-1">Envío:</label>
          </div>
          <div class="col-7 pt-1 text-left">
            {{ shippingTypeDescription }}
          </div>

          <div class="col-5 text-right px-0">
            <label class="pt-1 font-weight-bold" for="selectQuantity">Total a abonar</label>
          </div>
          <div class="col-7 pt-1 text-left font-weight-bold">
            {{ totalToPay.toFixed(2) | currency }}
          </div>

      </div>

      <!-- User warning -->
      <!-- <div class="buy-quantity-details mt-5 row">
        <div class="row">
          <div class="col-12">
            <h5 class="font-weight-bold">Importante</h5>
            <p class="text-justify px-3">Estás realizando este pago directamente a {{ userName }}.
              Realiza pagos solamente a vendedores de tu confianza.
            </p>
          </div>
        </div>
      </div> -->

    </div>

    <!-- Previous and next buttons -->
    <div class="buy-buttons col-sm-12">

      <SquaredButton
        @click="$router.go(-1)"
        styleType="link"
        label="Anterior"
      />

      <SquaredButton
        @click="nextTab"
        styleType="primary"
        label="Siguiente"
        :disabled="isFetching"
      />

    </div>

  </main>
</template>

<script>
import store from '@/store'
import Publication from '@/components/publication/CardWideMinimal'
import Publication2 from '@/components/publication/CardWide'

export default {
  components: {
    Publication,
    Publication2
  },

  props: {
    shippingType: String,
  },

  data: () => ({
    nextPressed: false,
  }),

  watch: {
    id (newId) {
      store.dispatch('buy/setPublicationId', newId);
    }
  },

  async created () {
    store.dispatch('buy/setPublicationId', this.id).then(resp => {
      setTimeout(() => {
        store.dispatch('buy/setQuantity', this.quantity)
      }, 2000);
    });
  },

  computed: {

    isFetching: () => store.state.isFetching,

    quantity: () => store.state.buy.quantity,

    priceBuyUnit: () => store.state.buy.price_buy_unit,

    totalToPay: () => store.state.buy.total_to_pay,

    details: () => store.getters['publication/preview'],

    id: () => store.state.publication.id,

    quantityOptions () {
      let values = []
      let stock = this.product[0] ? this.product[0].stock : 0
      for (let i = 0; i < stock; i++) {
        values = values.concat({value: i+1, text: `${i+1}`})
      }
      return values
    },

    product: () => store.state.publication.product,

    shippingTypeList: () => store.state.shippingTypeList,

    shippingTypeDescription: () => {
      let shippingTypeList = store.state.shippingTypeList
      let product = store.state.publication.product
      let response = product[0] ? shippingTypeList.find(item => item.value == product[0].shipping_type).text : null
      return response
    },

    userName () {
      let userName = '';
      if(this.details.user.person.physical_person) {
        userName = this.details.user.person.physical_person.first_name + ' '
          + this.details.user.person.physical_person.last_name
      } else {
        userName = this.details.user.person.legal_person.fantasy_name
        if(this.details.user.person.legal_person.razon_social)
          userName += ' (' + this.details.user.person.legal_person.razon_social + ')'
      }

      return userName
    }

  },

  methods: {

    handleQuantityChange (e) {
      store.dispatch('setIsFetching', true)
      store.dispatch('buy/setQuantity', parseInt(e.target.value)).then(res => {
        store.dispatch('setIsFetching', false)
      })
    },

    async nextTab () {

      store.dispatch('setIsFetching', true)

      store.dispatch('buy/createOrder').then(res => {
        if (this.shippingType == 'INCLUDED_IN_PRICE') {
          this.$emit('goToDelivery')
        } else {
          this.$emit('goToConfirmation')
        }
      })
      .finally(
        store.dispatch('setIsFetching', false)
      )
    }
  }
}
</script>

<style lang="scss">
  .buy-quantity-details {
      background-color: #F7F6F6;
      border-radius: 4px;
      padding: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/marketplace/tabs/TabQuantity.vue